import React, { useEffect } from "react";
import { connect }  from "react-redux";
import { FormattedMessage } from "react-intl";

// @mui/material components
import { Dialog, DialogTitle, DialogContent } from "@mui/material";

// actions
import { error as createError } from "actions/category/create";
import { error as updateError } from "actions/category/update";

// core components
import Form from './form';

function CreateDialog(props) {
    const { category, closeDialog, created, isOpen, isSubCategory, resetErrors } = props;

    // Validation errors of a previous submit must not show up in a newly opened form
    useEffect(() => {
        if (isOpen) {
            resetErrors();
        }
    }, [isOpen]);

    useEffect(() => {
        if (created) {
            closeDialog();
        }
    }, [created]);

    return (
        <Dialog
            open={isOpen}
            onClose={closeDialog}
            maxWidth={'sm'}
            scroll={'body'}
            // CKEditor balloons (link URL input) are rendered outside the dialog, the focus trap would steal their focus
            disableEnforceFocus
        >
            <DialogTitle>
                <FormattedMessage id={isSubCategory ? "category.form.sub.create.title" : "category.form.create.title"} />
            </DialogTitle>
            <DialogContent>
                <Form
                    closeDialog={closeDialog}
                    category={isSubCategory && category}
                    isSubCategory={isSubCategory}
                />
            </DialogContent>
        </Dialog>
    )
}

const mapStateToProps = state => {
    return {
        created: state.category.create.created,
    }
};

const mapDispatchToProps = dispatch => ({
    resetErrors: () => {
        dispatch(createError(null));
        dispatch(updateError(null));
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CreateDialog);
